/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReplyInputs */

const en_reply = /** @type {(inputs: ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply`)
};

const id_reply = /** @type {(inputs: ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balas`)
};

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const es_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const fr_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const de_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const ja_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const zh_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const ar_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const it_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const ru_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const pt_reply = en_reply;

/** @type {(inputs: ReplyInputs) => LocalizedString} */
const ko_reply = en_reply;

/**
* | output |
* | --- |
* | "Reply" |
*
* @param {ReplyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reply = /** @type {((inputs?: ReplyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReplyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reply(inputs)
	if (locale === "es") return es_reply(inputs)
	if (locale === "fr") return fr_reply(inputs)
	if (locale === "de") return de_reply(inputs)
	if (locale === "ja") return ja_reply(inputs)
	if (locale === "zh") return zh_reply(inputs)
	if (locale === "ar") return ar_reply(inputs)
	if (locale === "id") return id_reply(inputs)
	if (locale === "it") return it_reply(inputs)
	if (locale === "ru") return ru_reply(inputs)
	if (locale === "pt") return pt_reply(inputs)
	return ko_reply(inputs)
});